import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-surveys',
  templateUrl: './admin-surveys.component.html',
  styleUrls: ['./admin-surveys.component.scss'],
})
export class AdminSurveysComponent {
  constructor() {}
}
